<template>
    <div v-if="pageCount > 1" class="pagination inner">
        <a v-if="pageIndex > 1" @click="goToPrevPage()" class="button">{{ localizer.get("App.Pagination.Prev") }}</a>
        <a v-if="paginatorIndex >= 1" @click="goToPageSelector('less')" class="button dots">...</a>
        <div v-if="footerPages.length !== 0" class="pages">
            <a v-for="(page, index) in footerPages" :key="'page_' + index" @click="goToPage(page + 1)" :class="[{ 'selected': pageIndex - 1 === page }, 'button']">{{ page + 1 }}</a>
        </div>
        <a v-if="paginatorCount >= 1 && (paginatorIndex + 1) !== paginatorCount" @click="goToPageSelector('plus')" class="button dots">...</a>
        <a v-if="pageIndex !== pageCount" @click="goToNextPage()" class="button">{{ localizer.get("App.Pagination.Next") }}</a>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Localizer from "@Scripts/Common/Localizer";

const props = defineProps<{
    pageIndex: number,
    pageCount: number
}>();

const localizer = Localizer;

const footerPages = ref<any[]>([]);
const paginatorCount = ref(0);
const paginatorIndex = ref(0);

paginatorCount.value = Math.ceil(props.pageCount / 4);
paginatorIndex.value = Math.trunc((props.pageIndex - 1) / 4);
footerPages.value = [...Array(props.pageCount).keys()].slice(paginatorIndex.value * 4, (paginatorIndex.value + 1) * 4);

async function setSearch(index: number) {
    const url = new URL(window.location.href);
    url.searchParams.set("page", (index).toString());
    window.location.href = url.toString();
}

async function goToPage(index: number) {
    setSearch(index);
}

async function goToPrevPage() {
    if (props.pageIndex < 2) {
        return;
    }
    setSearch((props.pageIndex - 1));
}

async function goToNextPage() {
    if (props.pageIndex >= props.pageCount) {
        return;
    }
    setSearch((props.pageIndex + 1));
}

function goToPageSelector(type: string) {
    if (type === "plus") {
        goToPage(footerPages.value.slice(-1)[0] + 2);
    }

    if (type === "less") {
        goToPage(footerPages.value.slice(0)[0]);
    }
}
</script>
